module.exports = __webpack_public_path__ + "static/media/coderssb.b73f6b4f.png";